"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderBanner = exports.update = exports.get = void 0;
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGraphicsUtils_sidecar_1 = require("@voyage/ui/voyageUiGraphicsUtils-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 0;
    var th = 0;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiGame);
    canvas.autoOffset = false;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {});
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, true);
    return obj;
};
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var alpha = mathUtils_sidecar_1.mathUtils.sineLike(common_sidecar_1.common.getElapsedTime(), 4, 0.25, 1);
    var color = voyageColors_sidecar_1.voyageColors.red;
    var bannerWidth = 1280 - 35;
    var x = (gb.width - bannerWidth) / 2;
    var y = 60;
    if (voyageGameManager_sidecar_1.voyageGameManager.get().isPaused) {
        renderBanner(obj, x, y, color, alpha, 'Paused - Press Space');
    }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
var update = function () {
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
    render();
};
exports.update = update;
function renderBanner(obj, x, y, color, alpha, text) {
    var w = 200;
    var h = 40;
    var bevel = h / 2;
    var padding = 20;
    var g = obj.graphics;
    w = 200;
    g.fillStyle(color, alpha);
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel);
    g.fill();
    x += w + padding;
    w = 60;
    g.fillStyle(color, alpha);
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel);
    g.fill();
    x += w + padding;
    g.fillStyle(color, alpha);
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel);
    g.fill();
    x += w + padding;
    var addText = function (text, x, y) {
        var _text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font6, x, y, obj.layer);
        stevieTexts2_sidecar_1.stevieTexts2.setWrapWidth(_text, 500);
        stevieTexts2_sidecar_1.stevieTexts2.setText(_text, text);
        stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, 6);
        var colorText = 0xffffff;
        stevieTexts2_sidecar_1.stevieTexts2.setTint(_text, colorText);
        stevieTexts2_sidecar_1.stevieTexts2.setAlpha(_text, alpha);
        obj.texts.push(_text);
    };
    addText(text, x + 20, y + 20);
    x += 465 + padding;
    w = 60;
    g.fillStyle(color, alpha);
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel);
    g.fill();
    x += w + padding;
    g.fillStyle(color, alpha);
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel);
    g.fill();
    x += w + padding;
    w = 200;
    g.fillStyle(color, alpha);
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelArea(g, x, y, w, h, bevel);
    g.fill();
    x += w + padding;
}
exports.renderBanner = renderBanner;
